import React, { useContext, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, withRouter } from "react-router-dom";
import {
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Dropdown,
  CustomInput,
} from "reactstrap";
import AppContext from "./../../context/Context";
import { Logout, userIsFetching } from "../../actions/authActions";
import { checkUserToken } from "../../helpers/api/auth";
import { ArrowLeftRight, CircleUserRound, Coins, LogOut, Moon, Settings } from "lucide-react";
import { UnselectProperty } from "../../actions/propertyActions";
import { UnselectCondominium } from "../../actions/condominiumActions";

const ProfileDropdown = () => {
  const { isDark, setIsDark } = useContext(AppContext);
  const { setUser } = useContext(AppContext);

  const dispatch = useDispatch();

  const handleLogout = () => {
    dispatch(Logout());
  };
  const { role, token, hasMultipleProperties } = useSelector(
    (state) => state.auth.user
  );
  const { isFetching } = useSelector((state) => state.auth);
  const { selectedCondominium } = useSelector((state) => state.condominium);
  const [update, setUpdate] = useState(0);

  const handleChangeProperty = () => {
    dispatch(UnselectProperty());
    dispatch(UnselectCondominium());
  };

  const [profile, setProfile] = useState({
    data: null,
    error: null,
    isLoading: true,
  });

  const { data, isLoading } = profile;

  useEffect(() => {
    if (isFetching) {
      if (isFetching.profilePicture) {
        dispatch(userIsFetching({ profilePicture: false }));
      }
      if (!isFetching.profilePicture) {
        setUpdate(update + 1);
      }
    }
    // eslint-disable-next-line
  }, [isFetching]);

  useEffect(() => {
    let isMounted = true;
    if (token) {
      const getProfile = async () => {
        try {
          const { data } = await checkUserToken(token);
          if (isMounted) {
            setProfile((prev) => {
              return { ...prev, data, isLoading: false };
            });
            setUser(data);
          }
        } catch (e) {
          if (isMounted) {
            setProfile((prev) => {
              return { ...prev, error: e, isLoading: false };
            });
          }
        }
      };
      getProfile();
    }
    return () => {
      isMounted = false;
    };
    // eslint-disable-next-line
  }, [update]);

  const [dropdownOpen, setDropdownOpen] = useState(false);
  const toggle = () => setDropdownOpen((prevState) => !prevState);

  const roleLabel = {
    manager: "Administrador",
    property: "Propietario",
    safety: "Vigilante",
    root: "Root",
    provider: "Proveedor",
  }[role];
  const fullName = [data?.firstname, data?.lastname].filter(Boolean).join(" ") || roleLabel || "Mi cuenta";
  const initials =
    [data?.firstname, data?.lastname]
      .filter(Boolean)
      .map((part) => part.trim().charAt(0))
      .join("")
      .toUpperCase() || (roleLabel || "H").charAt(0);

  return (
    <Dropdown nav inNavbar isOpen={dropdownOpen} toggle={toggle}>
      <DropdownToggle nav className="p-0" aria-label="Menú de la cuenta">
        <span className={`hl-avatar${isLoading ? " spinner-grow" : ""}`}>
          {!isLoading && data?.image ? <img src={`${data.image}`} alt="" /> : initials}
        </span>
      </DropdownToggle>
      <DropdownMenu right className="hl-profile-menu">
        <div className="hl-profile-menu__header">
          <div className="hl-profile-menu__name">{fullName}</div>
          {data?.email && <div className="hl-profile-menu__email">{data.email}</div>}
        </div>
        <DropdownItem divider />
        <DropdownItem tag={Link} to={role === "provider" ? "/provider/profile" : `/dashboard/my/profile`}>
          <CircleUserRound size={18} strokeWidth={1.75} aria-hidden="true" />
          Perfil y cuenta
        </DropdownItem>
        {selectedCondominium && role === "manager" && (
          <DropdownItem tag={Link} to="/dashboard/config">
            <Settings size={18} strokeWidth={1.75} aria-hidden="true" />
            Configuración
          </DropdownItem>
        )}
        {role === "manager" && (
          <DropdownItem tag={Link} to="/dashboard/currency">
            <Coins size={18} strokeWidth={1.75} aria-hidden="true" />
            Configuración de moneda
          </DropdownItem>
        )}
        {role === "property" && hasMultipleProperties && (
          <DropdownItem tag={Link} to="/dashboard/app" onClick={handleChangeProperty}>
            <ArrowLeftRight size={18} strokeWidth={1.75} aria-hidden="true" />
            Cambiar de propiedad
          </DropdownItem>
        )}
        <DropdownItem divider />
        <DropdownItem toggle={false} onClick={() => setIsDark(!isDark)}>
          <Moon size={18} strokeWidth={1.75} aria-hidden="true" />
          Tema oscuro
          <CustomInput
            type="switch"
            id="dark-mode-switch"
            checked={isDark}
            onChange={({ target }) => setIsDark(target.checked)}
            onClick={(event) => event.stopPropagation()}
            aria-label="Tema oscuro"
          />
        </DropdownItem>
        <DropdownItem divider />
        <DropdownItem onClick={handleLogout}>
          <LogOut size={18} strokeWidth={1.75} aria-hidden="true" />
          Cerrar sesión
        </DropdownItem>
      </DropdownMenu>
    </Dropdown>
  );
};

export default ProfileDropdown;
